@if (active) {
    <span class="inline-block h-3 w-3 rounded-full bg-success" kendoTooltip title="{{ 'Active' | translate }}"></span>
} @else {
    <span
        class="inline-block h-3 w-3 rounded-full bg-danger"
        kendoTooltip
        title="{{ 'Deactivated' | translate }}"></span>
}
